// Functions to switch / get element(s) attribute
export const disableElement = element => {
  if (element.length) {
    element.attr("disabled", "disabled");
  }
};

export const enableElement = element => {
  if (element.length) {
    element.removeAttr("disabled", false);
  }
};
